export class RecordHelper {
    static size<T>(record?: Record<string, T>): number {
        return record ? Object.keys(record).length : 0;
    }

    static has<T>(record: Record<string, T>, key: string): boolean {
        return Object.prototype.hasOwnProperty.call(record, key);
    }

    static get<T>(record: Record<string, T>, key: string): T | undefined {
        return record[key];
    }

    static set<T>(record: Record<string, T>, key: string, value: T): void {
        record[key] = value;
    }

    static delete<T>(record: Record<string, T>, key: string): void {
        delete record[key];
    }

    static isEmpty = <T>(record?: Record<string, T>) => {
        return !record || Object.keys(record).length === 0
    }

    static toArray = <T>(record?: Record<string, T>) => {
        return record ? Object.entries(record) : [];
    }

    static toKeys = <T>(record?: Record<string, T>) => {
        return record ? Object.keys(record) : [];
    }

    static toValues = <T>(record?: Record<string, T>) => {
        return record ? Object.values(record) : [];
    }
}
